import Product from '../../domains/Product/Product'
import { SvDetails } from '../../domains/ProductPurchaseInfo'

import { getVariantDetailsByIdForProductVariants } from './NewCheckoutProductService'

export async function getSvDetailsByIdForProductVariants(
  product: Product,
  isB2BSelfService?: boolean,
): Promise<Record<number, SvDetails>> {
  return await getVariantDetailsByIdForProductVariants(product, isB2BSelfService)
}
